<template>
  <div class="main-container">
    <canvas id="canvasRender" style="z-index: 100"></canvas>
  </div>
  <MobileSellControlTable
      ref="sellControlRef"
      v-model:visible="drawerVisible"
      :building-info="buildingList"
      @handleDrawer="handleDrawer"
      @switchBuild="switchBuild"
      @showAllBuild="showAllBuild"
      @roomDetail="roomDetail"
  />
  <!-- 添加蒙层元素 -->
  <div v-if="showOverlay" class="overlay"></div>
</template>
<script >
import {getCommunityDetail, isMember, getResidentialByCode, getRoadByCode, checkPageAccess, checkPwd} from '@/utils/api'
import HouseResourcesViewOpen  from './HouseResources'
import { getByBuildingIds } from '@/utils/sellControlTableApi'
import { Modal } from 'ant-design-vue';
import { ref } from 'vue';
import MobileSellControlTable from "@/common/SellControlerTable.vue";
import { h } from 'vue';
let houseResourcesView = null;


export default {
  components: {MobileSellControlTable},
  data() {
    return {
      showOverlay: false,
      buildNumbers: [],
      drawerVisible: ref(false),
      buildingList: ref(),
      showSalesControlTable: false,
      controlDataMap: new Map(),
      showCard: false,
      selectedBuild:'',
      singleSelect: false
    }
  },
  mounted() {
  },
  created() {
    checkPageAccess(this.$route.params.code, 5).then((res) => {
      if (res.data.code === 200) {
        this.initPage(res.data.result);
      } else {
        if(res.data.result){
          this.needPassword = true;
          this.showPasswordModal(res.data.result);
        }else{
          Modal.error({
            title: '提示',
            content: res.data.message || '检查页面访问权限失败',
          });
        }
      }
    }).catch((error) => {
      console.error('网络请求出错', error);
      Modal.error({
        title: '提示',
        content: '网络请求出错，请稍后重试',
      })
    })
  },
  methods: {
    async initPage(code){
      document.title = "3D楼盘建模大师";
      getResidentialByCode(code).then((res) => {
        if (res.data.code === 200) {
          this.residentialName = res.data.result.residentialName;
        }
      })

      await isMember(code).then((res) => {
        if(res.data.result != null) {
          if(res.data.result.businessMemberType === 2){
            document.title = this.residentialName;
          }else if(res.data.result.businessMemberType === 3){
            this.showSalesControlTable = true
            document.title = this.residentialName;
          } else if(res.data.result.businessMemberType !== 2 &&  res.data.result.businessMemberType !== 3) {
            this.watermark = ['3D楼盘建模大师', '秦皇岛三角龙科技有限公司'];
            this.showOverlay = true;
            Modal.error({
              title: '提示',
              content: '当前账号未开通会员服务，该页面暂停访问',
              zIndex: 1002
            })
          }
        } else {
          this.watermark = ['3D楼盘建模大师', '秦皇岛三角龙科技有限公司'];
        }
      })
      if(this.showOverlay === true){
        return
      }
      await getCommunityDetail(code).then((res) => {
        let minBaseHeight = 0;
        if (res.data.code === 200) {
          this.buildingList = res.data.result.barrierReqList.filter(item => item.houseList.length > 0)
          // 获取所有buildingId并调用接口
          const buildingIds = this.buildingList.map(item => item.buildingId)
          let result = res.data.result;
          result.barrierReqList.forEach(element => {
            if (element.houseList.length > 0) {
              this.buildNumbers.push(element.buildingNumber);
            }
            if(element.baseHeight < minBaseHeight || minBaseHeight === 0){
              minBaseHeight = element.baseHeight;
            }
          });
          // 对 buildNumbers 进行排序
          this.buildNumbers.sort((a, b) => {
            const isANumber = !isNaN(parseFloat(a)) && isFinite(a);
            const isBNumber = !isNaN(parseFloat(b)) && isFinite(b);
            if (isANumber && isBNumber) {
              return parseFloat(a) - parseFloat(b);
            } else if (isANumber) {
              return -1;
            } else if (isBNumber) {
              return 1;
            }
            return a.localeCompare(b);
          });
          this.tableBuildNumber = this.buildNumbers[0];
          getRoadByCode(code).then((res) => {
            if (res.data.code == 200) {
              result.roadList = res.data.result;
            }
            getByBuildingIds(buildingIds).then(controlRes => {
              if (controlRes.data.code === 200) {
                // 创建buildingId到销控数据的映射
                controlRes.data.result.forEach(item => {
                  this.controlDataMap.set(item.buildingNumber, item.sellControlList)
                })
                // 将销控数据填充到buildingList中
                this.buildingList.forEach(building => {
                  building.sellControlList = this.controlDataMap.get(building.buildingNumber) || []
                })
              }
              houseResourcesView = new HouseResourcesViewOpen({
                element: document.querySelector("#canvasRender"),
                history: result,
                sellControlMap: this.controlDataMap,
                onSwitchBuild: this.onSwitchBuild,
                onRoomDetail: this.roomDetail,
                minBaseHeight: minBaseHeight
              });
              houseResourcesView.init();
            })
          })
        } else {
          Modal.error({
            title: '提示',
            content: res.data.message || '请求失败',
          })
        }
      })
    },
    showPasswordModal(id){
      Modal.confirm({
        title: '请输入密码',
        content: h('input', {
          style: 'border: 1px solid #ccc; border-radius: 4px;',
          type: 'password',
          value: this.password,
          placeholder: '请输入访问密码',
          onInput: (e) => this.password = e.target.value
        }),
        okText: '确认',
        cancelText: '取消',
        onOk: () => this.checkPassword(id),
        onCancel: () => {}
      });
    },
    checkPassword (id) {
      checkPwd(id, this.password).then((res) => {
        if (res.data.code === 200) {
          this.initPage(res.data.result);
          this.needPassword = false;
        } else {
          Modal.error({
            title: '提示',
            content: res.data.message || '密码错误，请重新输入',
            okText: '重新输入',
            onOk: () => {
              this.password = ''; // 清空密码输入框内容
              this.showPasswordModal(id); // 重新打开密码输入框
            }
          });
        }
      })
    },
    // 显示抽屉
    showDrawer (){
      this.drawerVisible = true;
    },
    // 抽屉关闭回调
    handleDrawer (visible) {
      this.showCard = visible;
    },
    switchBuild (building) {
      if (houseResourcesView)
      {
        houseResourcesView.switchHighlightBuilding(building.buildingNumber)
        this.singleSelect = true
      }
      this.selectedBuild = building.buildingNumber
    },
    onSwitchBuild (buildingNumber) {
      this.$refs.sellControlRef.renderChangeBuilding(buildingNumber)
    },
    showAllBuild () {
      if (houseResourcesView)
      {
        houseResourcesView.switchHighlightBuilding()
      }
      if (this.showCard) {
        this.$refs.sellControlRef.togglePanel()
      }
      this.singleSelect = false
      this.selectedBuild = ''
    },
    roomDetail (roomKey, source) {
      const roomKeyArr = roomKey.split('_')
      if (roomKeyArr.length < 4)
        return
      if (source === '3D') {
        //调用表格方法
        const buildingNumber = roomKeyArr[0]
        const unit = roomKeyArr[1]
        const floor = roomKeyArr[2]
        const room = roomKeyArr[3]
        const buildRecord = this.controlDataMap.get(buildingNumber)
        let sourceRecord = []
        if (buildRecord) {
          sourceRecord = buildRecord.filter(item => 
            Number(item.floor) === Number(floor)
            && Number(item.unit) === Number(unit)
            && item.room === room
          )
        }
        this.$refs.sellControlRef.showRoomDetailBy3D(unit, floor, room, sourceRecord)
      }
      if (source === 'table') {
        if(!this.singleSelect){
          if (houseResourcesView){
            houseResourcesView.switchHighlightBuilding(roomKeyArr[0])
            this.singleSelect = true
            this.selectedBuild = roomKeyArr[0]
          }
        }
        houseResourcesView.switchSelectRoomByTable(roomKey)
      }
    }
  }
}
</script>
<style scoped>
.main-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
}

.sell-control-btn {
  position: fixed;
  bottom: 24px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 101;
}

.sell-control-btn .ant-btn {
  height: 40px;
  font-size: 16px;
  padding: 0 24px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
}
/* 添加蒙层样式 */
.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(58, 58, 58, 0.8);
  z-index: 1001;
}
</style>